const InputText = (app) => {
  const configure = app.configure;
  const $container = app.$container;
  const _ = require('lodash');
  /* ================================================================
  =            Update dynamically Max Length for input.             =
  ================================================================ */
  const enteredText = {};
  let previouslySelected = { id: 0 };
  let updateEnteredText = true;
  const getRestrictionLabel = type => app.l10n.getLang(`restriction_label_${type}`, `up to {MAX_CHAR} ${type}`);
  const setRestrictionLabel = (targetAlias, maxLength, facets) => {
    const facet = facets[
      targetAlias
        .replace('_text', '_type')
        .replace('type_', 'dtg_text_')
        .replace('_denim', '')
        .replace('_ui', '')
    ];

    if (!facet) {
      return;
    }

    const type = facet.name.toLowerCase();

    if (type === 'n/a') {
      return;
    }
    const text = getRestrictionLabel(type).replace('{MAX_CHAR}', maxLength);
    $container.find(`.fc-attribute-selector-alias-${targetAlias} .fc-text-restriction-label`).text(text);
  };
  const getTargetAlias = target => `type_${target.slice(9)}_text`;
  const setMaxLength = (alias, maxLength) => {
    const input = $container.find(`.fc-attribute-selector-alias-${alias} input`);
    input.attr('maxlength', maxLength);
    // RAL-1715 / Enforce maxlength limitations on browsers that do not support the attribute
    const value = input.val();
    if (value && value.length > maxLength) {
      configure.run('selectValue', { ca: { alias }, av: { text: value.slice(0, maxLength) } });
    }
  };
  const setTextLength = (target, maxLength, facets) => {
    const targetAlias = app.appUtils.hasUiAlias(getTargetAlias(target));

    // For Print and Embroidery products we need to pull the max length value
    // from the input field itself as it is unrelated to the embroidery selection.
    // This only applies to type_1_text and type_2_text
    if (app.appUtils.isPrintAndEmbroideryProduct()) {
      if (
        targetAlias === 'type_1_text' ||
        targetAlias === 'type_1_text_ui' ||
        targetAlias === 'type_2_text' ||
        targetAlias === 'type_2_text_ui'
      ) {
        maxLength = configure.run('getAttribute', { alias: targetAlias }).maxLength;
      }
    }

    if (app.helpers.hasAttribute(targetAlias)) {
      setMaxLength(targetAlias, maxLength);
      setRestrictionLabel(targetAlias, maxLength, facets);
    }
  };

  // If the product is Denim and the current key type_1_text has a
  // denim variant (e.g. type_1_text_denim), then use the _denim version
  const validateMetaData = (metadata, key, value) => {
    if (app.appUtils.isDenimProduct()) {
      const newValue = metadata[`${key}_denim`];
      value = (newValue) ? newValue : value;
    }
    return value;
  };

  const updateTextforAlias = (alias, text) => $container.find(`.fc-attribute-selector-alias-${alias} input`).val(text);
  const updateTextInput = (metadata) => {
    const updates = [];
    _.map(metadata, (value, key) => {
      if (/max_char/.test(key)) {
        value = validateMetaData(metadata, key, value);
        const targetAlias = getTargetAlias(key);
        if (app.helpers.hasAttribute(targetAlias)) {
          const targetCA = configure.run('getAttribute', { alias: targetAlias });
          let updatedText;
          if (enteredText[targetCA.id]) {
            updatedText = enteredText[targetCA.id].slice(0, value);
          } else if (targetCA.value && targetCA.value.text && targetCA.value.text.length > value) {
            // Text in recipe exceeds max length
            updatedText = targetCA.value.text.slice(0, value);
          }
          if (updatedText) {
            updateTextforAlias(targetAlias, updatedText);
            updates.push({ ca: { alias: targetAlias }, av: { text: updatedText } });
          }
        }
      }
    });
    // We need to skip the update of the entered text when we trigger the change on the input,
    // because the user is not typing on the input box.
    updateEnteredText = false;
    setTimeout(function () {
      updateEnteredText = true;
      // after 300 ms we asume all the changes have been completed, so we allow the stored text
      // to be updated when the user types on the input box.
    }, 300);
    configure.run('setRecipe', updates, app._callback);
  };

  const updateMaxLength = () => {
    const artworkColorIndex = app.helpers.getSelectedValueByAlias(app.appUtils.hasUiAlias('artwork_color_index'));
    const facets = app.helpers.getFacetsByAlias(app.appUtils.hasUiAlias('artwork_color_index'));
    const metadata = app.utils.getMetaData(artworkColorIndex);
    _.map(metadata, (value, key) => {
      if (/max_char/.test(key)) {
        value = validateMetaData(metadata, key, value);

        _.defer(setTextLength, key, value, facets);
      }
    });
    if (previouslySelected.id !== artworkColorIndex.id) {
      _.defer(updateTextInput, metadata);
      previouslySelected = artworkColorIndex;
    }
  };
  const updateStoredText = (change) => {
    if (updateEnteredText) {
      enteredText[change.caId] = change.text || '';
    }
  };
  /* =====  End of Update dynamically Max Length for input.  ====== */
  return {
    updateMaxLength,
    updateStoredText
  };
};

module.exports = InputText;
